import { FC } from 'react';
import { ShopContent } from '../../../types/cms_shared_types';
import { Conditional } from '../../Common/Conditional';
import { LoadingSpinner } from '../../Common/LoadingSpinner';

interface TotalPriceProps {
  price: string;
  vatPrice: string;
  totalPriceFetching: boolean;
  cmsShopContent: ShopContent;
}

export const TotalPrice: FC<TotalPriceProps> = ({ price, vatPrice, totalPriceFetching, cmsShopContent }) => {
  return (
    <div className="flex flex-row mx-3 mt-4 sm:ml-6 sm:mr-16">
      <div className="flex flex-col items-start">
        <div className="text-base font-bold text-text-dark sm:text-xl">
          {cmsShopContent.shoppingCart.shoppingCartModal.total}
        </div>
        <div className="font-medium text-text-gray">{cmsShopContent.shoppingCart.shoppingCartModal.vat}</div>
      </div>
      <div className="flex flex-col items-end self-center ml-auto">
        <Conditional
          condition={totalPriceFetching}
          trueRender={<LoadingSpinner />}
          falseRender={
            <div className="flex flex-col items-end">
              <div className="text-base font-bold text-text-dark sm:text-xl">
                {price} {cmsShopContent.priceWithMonthFormat}
              </div>
              <div className="font-medium text-text-gray">
                {vatPrice} {cmsShopContent.priceWithoutMonthFormat}
              </div>
            </div>
          }
        />
      </div>
    </div>
  );
};
